"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Error = _interopRequireDefault(require("@tvg/fuse-icons/lib/Error"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var checkboxConfig = {
  errorIcon: {
    icon: /*#__PURE__*/_react["default"].createElement(_Error["default"], null),
    color: 'var(--color-universal-redMid)',
    className: 'fuse-checkbox__error-icon',
    dataTestId: 'fuse-checkbox__error-icon',
    size: 'small'
  },
  errorText: {
    color: 'var(--color-universal-redMid)',
    className: 'fuse-checkbox__error-text',
    dataTestId: 'fuse-checkbox__error-text',
    size: 'm1',
    tag: 'span',
    type: 'paragraph'
  }
};
var _default = exports["default"] = checkboxConfig;